import React from 'react';

const URL_REGEX = /https?:\/\/[^\s<]+|www\.[^\s<]+/g;

/**
 * Takes a message string and returns React elements with URLs
 * rendered as clickable links.
 */
export function linkifyText(text, linkClassName = 'text-blue-600 underline break-all') {
  if (!text) return text;

  const matches = [];
  let match;
  while ((match = URL_REGEX.exec(text)) !== null) {
    matches.push({ index: match.index, length: match[0].length, url: match[0] });
  }

  if (matches.length === 0) return text;

  const elements = [];
  let lastIndex = 0;

  matches.forEach((m, i) => {
    if (m.index > lastIndex) {
      elements.push(text.slice(lastIndex, m.index));
    }
    const href = m.url.startsWith('http') ? m.url : `https://${m.url}`;
    elements.push(
      <a
        key={i}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
        onClick={(e) => e.stopPropagation()}
      >
        {m.url}
      </a>
    );
    lastIndex = m.index + m.length;
  });

  if (lastIndex < text.length) {
    elements.push(text.slice(lastIndex));
  }

  return elements;
}
